import React, { useState } from "react";
import { StldInput } from '../../styled-components/StyledInput.style';



export const DynamicTextarea = ({placeholder, label, name}) => {
    const [focused, isFocused] = useState(null);
    const [inputValue, getInputValue] = useState('');
    return (
        <StldInput onMouseEnter={() => isFocused(name)} onMouseLeave={() => isFocused(null)} >
            <label className={`${focused === name || !!inputValue ? 'focused' : ''}`}>{label}</label>
            <textarea rows="5" placeholder={!!focused ? placeholder : ''} name={name} value={inputValue} onChange={(event) => getInputValue(event.target.value)} />
        </StldInput>
    )
}

export const DynamicTextareaOnChange = ({ placeholder, label, name, valuetext, onChange, required }) => {
    const [focused, isFocused] = useState(null);
    
    // REMOVIDO: const [inputValue, getInputValue] = useState(''); 
    // MOTIVO: Quem deve controlar o valor é o Modal (pai), não o textarea (filho).

    return (
        <StldInput onMouseEnter={() => isFocused(name)} onMouseLeave={() => isFocused(null)} >
            {/* Ajustei a lógica da label para checar 'valuetext' também */}
            <label className={`${focused === name || (valuetext && valuetext.length > 0) ? 'focused' : ''}`}>
                {label}
                {required && <span style={{ color: 'red', marginLeft: '4px' }}>*</span>}
            </label>
            
            <textarea 
                rows="5" 
                placeholder={!!focused ? placeholder : ''} 
                name={name} 
                
                // O segredo está aqui: Ligar as props ao HTML nativo
                value={valuetext} 
                onChange={onChange} 
                required={required}
            />
        </StldInput>
    )
}